import api from "../../api/api";
import { toast } from "react-toastify";
import {
  FETCH_MEMBERSHIP_REQUESTS_REQUEST,
  FETCH_MEMBERSHIP_REQUESTS_SUCCESS,
  FETCH_MEMBERSHIP_REQUESTS_FAILURE,
  FETCH_MEMBERSHIP_REQUEST_DETAILS_REQUEST,
  FETCH_MEMBERSHIP_REQUEST_DETAILS_SUCCESS,
  FETCH_MEMBERSHIP_REQUEST_DETAILS_FAILURE,
  DELETE_MEMBERSHIP_REQUEST_REQUEST,
  DELETE_MEMBERSHIP_REQUEST_SUCCESS,
  DELETE_MEMBERSHIP_REQUEST_FAILURE,
  CLEAR_MEMBERSHIP_REQUESTS_ERROR,
} from "./membershipRequestActionTypes";

// ✅ Helpers to extract IDs from localStorage
const getUserId = () => parseInt(localStorage.getItem("loggedInUserId"), 10);
const getUserRoleId = () =>
  parseInt(localStorage.getItem("loggedInUserRoleId"), 10);

const handleError = (error, context) => {
  console.error(`API - ${context} error:`, error);
  if (error.response) {
    const { status, data } = error.response;
    switch (status) {
      case 400:
        return (
          data.message ||
          data.errors?.commentText?.[0] ||
          "Bad request. Please check your input."
        );
      case 401:
        localStorage.clear();
        window.location.href = "/";
        return "Session expired. Please log in again.";
      case 403:
        return "You do not have permission to perform this action.";
      case 404:
        return "No membership requests found. Please try again.";
      case 409:
        return data.message || "Request already exists.";
      case 500:
        return "Server error. Please try again later.";
      default:
        return data.message || "An unknown error occurred.";
    }
  }
  if (error.request) {
    return "No response received from the server. Please try again later.";
  }
  return error.message || "An unknown error occurred.";
};

// 🔹 Fetch request details
// export const fetchMembershipRequestDetails = (requestId) => async (dispatch) => {
//   dispatch({ type: FETCH_MEMBERSHIP_REQUEST_DETAILS_REQUEST });
//   try {
//     console.log(
//       `API - fetchMembershipRequestDetails for /MembershipProcessor/${requestId}/confirm-details`
//     );
//     const response = await api.get(
//       `/MembershipProcessor/${requestId}/confirm-details`,
//       {
//         headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
//       }
//     );
//     console.log("API - fetchMembershipRequestDetails response:", response.data);
//     dispatch({
//       type: FETCH_MEMBERSHIP_REQUEST_DETAILS_SUCCESS,
//       payload: response.data,
//     });
//     return response.data;
//   } catch (error) {
//     const errorMessage = handleError(error, "fetchMembershipRequestDetails");
//     dispatch({
//       type: FETCH_MEMBERSHIP_REQUEST_DETAILS_FAILURE,
//       payload: errorMessage,
//     });
//     toast.error("Failed to fetch membership request details: " + errorMessage);
//     throw error;
//   }
// };

export const fetchMembershipRequestDetails = (requestId) => async (dispatch) => {
    dispatch({ type: FETCH_MEMBERSHIP_REQUEST_DETAILS_REQUEST });
    try {
      console.log(
        `API - fetchMembershipRequestDetails for /MembershipProcessor/${requestId}/confirm-details`,
      );
      const response = await api.get(
        `/MembershipProcessor/${requestId}/confirm-details`,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        },
      );
      console.log(
        "API - fetchMembershipRequestDetails response:",
        response.data,
      );
      dispatch({
        type: FETCH_MEMBERSHIP_REQUEST_DETAILS_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } catch (error) {
      const errorMessage = handleError(error, "fetchMembershipRequestDetails");
      dispatch({
        type: FETCH_MEMBERSHIP_REQUEST_DETAILS_FAILURE,
        payload: errorMessage,
      });
      toast.error(
        "Failed to fetch membership request details: " + errorMessage,
      );
      throw error;
    }
};


// 🔹 Verify request (newStatusId = 11)
export const verifyMembershipRequest = (payload) => async (dispatch) => {
  // Get user info from localStorage
  const userRoleId = parseInt(localStorage.getItem("loggedInUserRoleId"), 10);
  const userId = parseInt(localStorage.getItem("loggedInUserId"), 10);

  if (!userRoleId || !userId) {
    const errorMessage = "User ID or Role ID not found. Please log in again.";
    dispatch({
      type: FETCH_MEMBERSHIP_REQUEST_DETAILS_FAILURE,
      payload: errorMessage,
    });
    toast.error(errorMessage);
    throw new Error(errorMessage);
  }

  const membershipId = payload?.membershipId;
  const commentText = payload?.commentText || "Verified";

  if (!membershipId) {
    const errorMessage = "Membership ID is missing.";
    dispatch({
      type: FETCH_MEMBERSHIP_REQUEST_DETAILS_FAILURE,
      payload: errorMessage,
    });
    toast.error(errorMessage);
    throw new Error(errorMessage);
  }

  try {
    const url = `/MembershipProcessor/process?membershipId=${membershipId}&newStatusId=11&userRoleId=${userRoleId}&userId=${userId}&commentText=${encodeURIComponent(commentText)}`;
    console.log("API - verifyMembershipRequest for", url);

    const response = await api.post(
      url,
      {}, // body is empty, API expects query params
      { headers: { Authorization: `Bearer ${localStorage.getItem("accessToken")}` } }
    );

    console.log("API - verifyMembershipRequest response:", response.data);
    dispatch(fetchMembershipRequestDetails(membershipId));
    toast.success("Membership request verified successfully!");
    return response.data;
  } catch (error) {
    const errorMessage = handleError(error, "verifyMembershipRequest");
    dispatch({
      type: FETCH_MEMBERSHIP_REQUEST_DETAILS_FAILURE,
      payload: errorMessage,
    });
    toast.error("Failed to verify membership request: " + errorMessage);
    throw error;
  }
};



// 🔹 Approve request (newStatusId = 2)
export const approveMembershipRequest = (payload) => async (dispatch) => {
  // Get user info from localStorage
  const userRoleId = parseInt(localStorage.getItem("loggedInUserRoleId"), 10);
  const userId = parseInt(localStorage.getItem("loggedInUserId"), 10);

  if (!userRoleId || !userId) {
    const errorMessage = "User ID or Role ID not found. Please log in again.";
    dispatch({
      type: FETCH_MEMBERSHIP_REQUEST_DETAILS_FAILURE,
      payload: errorMessage,
    });
    toast.error(errorMessage);
    throw new Error(errorMessage);
  }

  const membershipId = payload?.membershipId;
  const commentText = payload?.commentText || "Approved";

  if (!membershipId) {
    const errorMessage = "Membership ID is missing.";
    dispatch({
      type: FETCH_MEMBERSHIP_REQUEST_DETAILS_FAILURE,
      payload: errorMessage,
    });
    toast.error(errorMessage);
    throw new Error(errorMessage);
  }

  try {
    const url = `/MembershipProcessor/process?membershipId=${membershipId}&newStatusId=2&userRoleId=${userRoleId}&userId=${userId}&commentText=${encodeURIComponent(commentText)}`;

    const response = await api.post(
      url,
      {}, // body is empty, API expects query params
      { headers: { Authorization: `Bearer ${localStorage.getItem("accessToken")}` } }
    );

    console.log("API - approveMembershipRequest response:", response.data);
    dispatch(fetchMembershipRequestDetails(membershipId));
    toast.success("Membership request approved successfully!");
    return response.data;
  } catch (error) {
    const errorMessage = handleError(error, "approveMembershipRequest");
    dispatch({
      type: FETCH_MEMBERSHIP_REQUEST_DETAILS_FAILURE,
      payload: errorMessage,
    });
    toast.error("Failed to approve membership request: " + errorMessage);
    throw error;
  }
};




// 🔹 Query request (newStatusId = 5)
export const queryMembershipRequest = ({ membershipId, commentText }) => async (dispatch) => {
  const userRoleId = getUserRoleId();
  const userId = getUserId();

  if (!userRoleId || !userId) {
    const errorMessage = "User ID or Role ID not found. Please log in again.";
    dispatch({ type: FETCH_MEMBERSHIP_REQUEST_DETAILS_FAILURE, payload: errorMessage });
    toast.error(errorMessage);
    throw new Error(errorMessage);
  }

  if (!commentText) {
    const errorMessage = "Comment text is required to query the request.";
    dispatch({ type: FETCH_MEMBERSHIP_REQUEST_DETAILS_FAILURE, payload: errorMessage });
    toast.error(errorMessage);
    throw new Error(errorMessage);
  }

  try {
    const url = `/MembershipProcessor/process?membershipId=${membershipId}&newStatusId=5&userRoleId=${userRoleId}&userId=${userId}&commentText=${encodeURIComponent(commentText)}`;
    console.log("API - queryMembershipRequest for", url);

    const response = await api.post(url, {}, {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    });

    console.log("API - queryMembershipRequest response:", response.data);
    dispatch(fetchMembershipRequestDetails(membershipId));
    toast.success("Membership request queried successfully!");
    return response.data;
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || "Failed to query membership request";
    dispatch({ type: FETCH_MEMBERSHIP_REQUEST_DETAILS_FAILURE, payload: errorMessage });
    toast.error(errorMessage);
    throw error;
  }
};


// 🔹 Reject membership request (newStatusId = 3)
export const rejectMembershipRequest = ({ membershipId, commentText }) => async (dispatch) => {
  const userRoleId = getUserRoleId();
  const userId = getUserId();

  if (!userRoleId || !userId) {
    const errorMessage = "User ID or Role ID not found. Please log in again.";
    dispatch({ type: FETCH_MEMBERSHIP_REQUEST_DETAILS_FAILURE, payload: errorMessage });
    toast.error(errorMessage);
    throw new Error(errorMessage);
  }

  if (!commentText) {
    const errorMessage = "Comment text is required to reject the request.";
    dispatch({ type: FETCH_MEMBERSHIP_REQUEST_DETAILS_FAILURE, payload: errorMessage });
    toast.error(errorMessage);
    throw new Error(errorMessage);
  }

  try {
    const url = `/MembershipProcessor/process?membershipId=${membershipId}&newStatusId=3&userRoleId=${userRoleId}&userId=${userId}&commentText=${encodeURIComponent(commentText)}`;
    console.log("API - rejectMembershipRequest for", url);

    const response = await api.post(url, {}, {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    });

    console.log("API - rejectMembershipRequest response:", response.data);
    dispatch(fetchMembershipRequestDetails(membershipId));
    toast.success("Membership request rejected successfully!");
    return response.data;
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || "Failed to reject membership request";
    dispatch({ type: FETCH_MEMBERSHIP_REQUEST_DETAILS_FAILURE, payload: errorMessage });
    toast.error(errorMessage);
    throw error;
  }
};


// 🔹 Fetch pending approvals
export const fetchMembershipRequests = () => async (dispatch) => {
  dispatch({ type: FETCH_MEMBERSHIP_REQUESTS_REQUEST });
  try {
    console.log("API - fetchMembershipRequests for /Memberships");
    const response = await api.get("/Memberships", {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    });
    console.log("API - fetchMembershipRequests response:", response.data);
    dispatch({
      type: FETCH_MEMBERSHIP_REQUESTS_SUCCESS,
      payload: response.data,
    });
    return response.data;
  } catch (error) {
    const errorMessage = handleError(error, "fetchMembershipRequests");
    dispatch({
      type: FETCH_MEMBERSHIP_REQUESTS_FAILURE,
      payload: errorMessage,
    });
    toast.error("Failed to fetch membership requests: " + errorMessage);
    throw error;
  }
};


export const fetchMembershipPendingApprovals = () => async (dispatch) => {
  dispatch({ type: FETCH_MEMBERSHIP_REQUESTS_REQUEST });
  try {
    const userId = localStorage.getItem("loggedInUserRoleId");
    if (!userId) {
      throw new Error("User ID is missing. Please log in again.");
    }
    console.log("API - fetchPendingMembershipApprovals for userId:", userId);
    const response = await api.get(
      `/MembershipProcessor/user/${userId}/memberships-pending-approval`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      },
    );
    console.log(
      "API - fetchPendingMembershipApprovals response:",
      response.data,
    );
    dispatch({
      type: FETCH_MEMBERSHIP_REQUESTS_SUCCESS,
      payload: response.data,
    });
    return response.data;
  } catch (error) {
    const errorMessage = handleError(error, "fetchPendingMembershipApprovals");
    dispatch({
      type: FETCH_MEMBERSHIP_REQUESTS_FAILURE,
      payload: errorMessage,
    });
    toast.error(errorMessage);
    throw error;
  }
};


// 🔹 Delete request
export const deleteMembershipRequest = (requestId) => async (dispatch) => {
  dispatch({ type: DELETE_MEMBERSHIP_REQUEST_REQUEST });
  try {
    console.log(`API - deleteMembershipRequest for /Memberships/${requestId}`);
    const response = await api.delete(`/Memberships/${requestId}`, {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    });
    console.log("API - deleteMembershipRequest response:", response.data);
    dispatch({
      type: DELETE_MEMBERSHIP_REQUEST_SUCCESS,
      payload: requestId,
    });
    return response.data;
  } catch (error) {
    const errorMessage = handleError(error, "deleteMembershipRequest");
    dispatch({
      type: DELETE_MEMBERSHIP_REQUEST_FAILURE,
      payload: errorMessage,
    });
    toast.error("Failed to delete membership request: " + errorMessage);
    throw error;
  }
};

// 🔹 Clear error state
export const clearMembershipRequestsError = () => ({
  type: CLEAR_MEMBERSHIP_REQUESTS_ERROR,
});
